import { useState, useEffect } from 'react';
import HeaderBar from "./components/HeaderBar";
import { useData, usePunishments } from './components/MemberData';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faXmark } from '@fortawesome/free-solid-svg-icons';
import '../styles/style.css'

import toast, { Toaster } from 'react-hot-toast';
import Cookies from 'js-cookie';
import Swal from 'sweetalert2';
import axios from 'axios';

let myDiscordID = ''

const API_URL = 'http://panelpolitie.fplayt.ro:5001';

const refreshAccessToken = async () => {
  try {
    const response = await axios.post(`${API_URL}/api/token`, {
      refreshToken: localStorage.getItem("refreshToken")
    });
    const { accessToken } = response.data;
    localStorage.setItem("token", accessToken);
    return accessToken;
  } catch (error) {
    throw new Error("Unable to refresh token");
  }
};

const makeAuthenticatedRequest = async (url: string, data: any) => {
  try {
    const token = localStorage.getItem("token");
    return await axios.post(url, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  } catch (err: any) {
    if (err.response.status === 403 || err.response.data?.error === "Invalid token") {
      try {
        const newToken = await refreshAccessToken();
        return await axios.post(url, data, {
          headers: {
            Authorization: `Bearer ${newToken}`
          }
        });
      } catch (refreshError) {
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        throw new Error("Session expired. Please log in again.");
      }
    } else {
      throw err;
    }
  }
};

function PunishmentsPage() {
    const [searchTerm, setSearchTerm] = useState('');
    const { getPoliceMemberInfo, policeMembersData } = useData();
    const { membersPunishments, fetchData } = usePunishments();
    const [isConducere, setIsConducere] = useState(false);
    
    useEffect(() => {
        let isConducereTemp = false;
        myDiscordID = Cookies.get('myDiscordID') || '';

        for (let index = 0; index < policeMembersData.length; index++) {
          const member = policeMembersData[index];
          let grade = member.grade.toUpperCase();
          if (member.discordID === myDiscordID && (grade === "SUB-INSPECTOR" || grade === "INSPECTOR" || grade === "INSPECTOR-PRINCIPAL" || grade === "SUB-COMISAR" || grade === "COMISAR" || grade === "COMISAR-SEF" || grade === "CHESTOR-GENERAL")) {
            isConducereTemp = true;
          }
        }
        setIsConducere(isConducereTemp);
    }, [policeMembersData]);
    
    const filteredPunishments = membersPunishments
    .filter((punishment) => {
        const searchLower = searchTerm.toLowerCase();
        return (
            String(punishment.callsign).padStart(3, '0').includes(searchLower) ||
            String(getPoliceMemberInfo(Number(punishment.callsign), "user_id")).includes(searchLower) ||
            getPoliceMemberInfo(Number(punishment.callsign), "full_name").toLowerCase().includes(searchLower)
        );
    })

    const [canPressFine, setPressFine] = useState(true);

    async function payFine(callsign: number, type: string, pType: string, reason: string) {
        if (canPressFine) {
            setPressFine(false);
            const result = await Swal.fire({
                title: `Esti sigur ca vrei sa platesti Amenda?`,
                text: `Această acțiune este ireversibilă!`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Da, continuă",
                cancelButtonText: "Anulează",
                confirmButtonColor: "#D8630F",
            });
                        
            if (!result.isConfirmed) {
                toast.success("Ai anulat acțiunea de platire!");
                return;
            } else {
                try {
                    await makeAuthenticatedRequest(`${API_URL}/api/pay-fine`, {
                        callsign,
                        type,
                        pType,
                        reason,
                        myDiscordID,
                        fullName: type === "pol" ? getPoliceMemberInfo(callsign, "full_name") : getPoliceMemberInfo(callsign, "full_name").toUpperCase(),
                    });
           
                    setPressFine(true);
                    toast.success(`Ai platit Amenda-ul lui [${callsign?.toString().padStart(3, '0')}]`);
                    fetchData();
                } catch (err: any) {
                    if (err.response.data.error === "Invalid token") {
                        toast.error("Token invalid! Te rugăm să te reconectezi.");
                        localStorage.removeItem("token");
                    } else {
                        toast.error("A aparut o eroare! Amenda-ul nu a fost platita.");
                    }
                }
            }
        }
    }

    async function deletePunishment(callsign: number, reason: string, type: string) {
        const result = await Swal.fire({
            title: `Esti sigur ca vrei sa stergi ${type === 'fw' ? "FW-ul" : "AMENDA"}?`,
            text: `Această acțiune este ireversibilă!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Da, continuă",
            cancelButtonText: "Anulează",
            confirmButtonColor: "#D8630F",
        });
                    
        if (!result.isConfirmed) {
            toast.success("Ai anulat acțiunea de stergere!");
            return;
        } else {
            try {
                await makeAuthenticatedRequest(`${API_URL}/punishment/delete`, {
                    callsign: callsign,
                    reason: reason,
                    type: type,
                    myDiscordID,
                    deleteFW: false
                });
                toast.success("Amenda stearsa cu succes!");
                fetchData();
            } catch (err: any) {
                if (err.response.data.error === "Invalid token") {
                    toast.error("Token invalid! Te rugăm să te reconectezi.");
                    localStorage.removeItem("token");
                } else {
                    toast.error("A aparut o eroare! Amenda-ul nu a fost stearsa.");
                }
            }
        }
    }

    function checkExpire(dateFW: string, daysExpire: string): string {
        if (daysExpire === "0") {
            return "Permanent";
        } else {
            const [day, month, year] = dateFW.split(".");
            const startDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day)); 
            const expireDays = parseInt(daysExpire);

            const expirationDate = new Date(startDate);
            expirationDate.setDate(startDate.getDate() + expireDays);

            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const timeDiff = expirationDate.getTime() - today.getTime();
            const daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

            return daysLeft > 0 ? `${daysLeft}` : "Expirat";
        }
    }

    async function checkPunishments() {
        fetchData();
        let count = 0;
        try {
            for (let index = 0; index < membersPunishments.length; index++) {
                const element = membersPunishments[index];
                if (element.pType === "fw") {
                    let expireStatus = checkExpire(JSON.parse(element.punishments).date, JSON.parse(element.punishments).daysExpire);
                    if (expireStatus === "Expirat") {
                        await makeAuthenticatedRequest(`${API_URL}/punishment/delete`, {
                            callsign: element.callsign,
                            reason: JSON.parse(element.punishments).reason,
                            type: element.type,
                            myDiscordID,
                            deleteFW: true
                        });
                        toast.success(`FW-ul lui [${element.callsign.toString().padStart(3, '0')}] a fost sters deoarece a expirat!`);
                        count++;
                    }
                }
            }
        } catch (err: any) {
            if (err.response.data.error === "Invalid token") {
                toast.error("Token invalid! Te rugăm să te reconectezi.");
                localStorage.removeItem("token");
            } else {
                toast.error("A aparut o eroare! Nu s-au putut verifica sancțiunile.");
            }
        }
        fetchData();
        if (count === 0) {
            toast.error("Nu s-au găsit FW-uri expirate!");
        }
    }

    return (
        <div className="w-full h-full flex flex-col">
            <HeaderBar currentPage="Sancțiuni"/>
            <div className="w-[99%] h-[87%] box-border p-[1%] pt-[0.5%] bg-[rgba(255,255,255,0.61)] dark:bg-[#605D5D61] flex flex-col gap-[1%] backdrop-blur-[32px] rounded-[1vw]">
                <div className="w-full h-[7%] flex items-center justify-between">
                    <span className="textSemiBold text-[1.1vw] text-[#000000] dark:text-[#ffffff]">Listă Sancțiuni</span>
                    <div onClick={checkPunishments} className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                        <span className="textBold text-white text-[.8vw]">VERIFICĂ SANCȚIUNI</span>
                    </div>
                    <div className="bg-[#00000010] dark:bg-[#ffffff10] border border-[#00000020] dark:border-[#ffffff20] w-[15%] h-[90%] rounded-full flex items-center justify-between box-border px-[1%]">
                        <input
                            type="text"
                            placeholder="Caută sancțiune (callsign)"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="pb-[1%] text-[#00000050] dark:text-[#ffffff50] dark:placeholder-[#ffffff50] placeholder-[#00000050] placeholder:text-[0.8vw] text-[0.8vw] bg-transparent h-full border-none outline-none"
                        />
                        <FontAwesomeIcon className="text-[#00000050] dark:text-[#ffffff50] text-[0.8vw]" icon={faMagnifyingGlass} />
                    </div>
                </div>
                <div className="bg-white dark:bg-[#323232] w-full h-[93%] rounded-xl flex flex-col overflow-y-scroll">
                    {Array.isArray(filteredPunishments) && filteredPunishments.length > 0 && (
                        filteredPunishments.map((punishment, index) => (
                        <div
                            key={index}
                            className="w-full min-h-[7%] flex items-center gap-[1%] box-border pl-[1%] pr-[1%] border-b-[1px] border-[#D0D0D0]"
                        >
                            <span className="textSemiBold w-[3%] text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">
                                {getPoliceMemberInfo(Number(punishment.callsign), "user_id")}
                            </span>
                            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                            <span className="textSemiBold w-[5%] text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">
                                [{punishment.type === "pol" ? String(punishment.callsign).padStart(3, '0') : `P-${String(punishment.callsign).padStart(2, '0')}`}]
                            </span>
                            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                            <span className="textSemiBold w-[10%] text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">
                                {getPoliceMemberInfo(Number(punishment.callsign), "full_name")}
                            </span>
                            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                            <span className="textSemiBold w-[5%] text-center text-red-500 text-[0.9vw]">
                                {JSON.parse(punishment.punishments).pType.toUpperCase()}
                            </span>
                            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                            <span className="textSemiBold w-[23%] text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">
                                {JSON.parse(punishment.punishments).reason}
                            </span>
                            {JSON.parse(punishment.punishments).pType.toUpperCase() !== "FW" ? (
                                <>
                                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                                    <span className="textSemiBold w-[5%] text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">
                                        {String(JSON.parse(punishment.punishments).amount).replace(/(.)(?=(\d{3})+$)/g,'$1,')}$
                                    </span>
                                </>
                            ) : (
                                <>
                                    <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                                    <span className="textSemiBold w-[5%] text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff] text-base/3">
                                        EXP: {checkExpire(JSON.parse(punishment.punishments).date, JSON.parse(punishment.punishments).daysExpire)}
                                    </span>
                                </>
                            )}
                            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                            <span className="textSemiBold w-[5%] text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">
                                {JSON.parse(punishment.punishments).date}
                            </span>
                            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                            <span className="textSemiBold w-[5%] text-center text-[#000000] text-[0.9vw] dark:text-[#ffffff]">
                                {JSON.parse(punishment.punishments).hr}
                            </span>
                            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                            {(JSON.parse(punishment.punishments).status === false && JSON.parse(punishment.punishments).pType.toUpperCase() !== "FW") ? (
                                isConducere === false ? (
                                    JSON.parse(punishment.punishments).pType.toUpperCase() === "AMENDA" && (
                                        <div className="w-[16%] h-full flex items-center justify-end">
                                            <div className="w-[39%] h-[70%] px-[1%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#ad0a0a] to-[#f51818]">
                                                <span className="textBold text-white text-[.8vw]">NEPLĂTIT</span>
                                            </div>
                                        </div>
                                    )
                                ) : (
                                    <div className="w-[22.5%] h-full flex items-center justify-end">
                                        <div
                                            onClick={() => payFine(Number(punishment.callsign), punishment.type, punishment.pType, JSON.parse(punishment.punishments).reason)}
                                            className="w-[39%] h-[70%] px-[1%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]"
                                        >
                                            <span className="textBold text-white text-[.8vw]">PLĂTEȘTE</span>
                                        </div>
                                    </div>
                                )
                            ) : (
                                JSON.parse(punishment.punishments).pType.toUpperCase() === "AMENDA" && (
                                    <div className="w-[22%] h-full flex items-center justify-end gap-[2%]">
                                        <div className="w-[35%] h-[70%] px-[1%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#367a25] to-[#33b512]">
                                            <span className="textBold text-white text-[.8vw]">PLĂTIT</span>
                                        </div>
                                        {isConducere === true && (
                                            <div onClick={() => deletePunishment(Number(punishment.callsign), JSON.parse(punishment.punishments).reason, punishment.type)} className="w-[11%] h-[70%] bg-[#ff0000ac] flex items-center justify-center rounded-[.2vw] cursor-pointer">
                                                <FontAwesomeIcon className="text-[1vw] text-white" icon={faXmark} />
                                            </div>
                                        )}
                                    </div>
                                )
                            )}
                        </div>
                    )))}
                </div>
            </div>
            <Toaster
                position="top-right"
                reverseOrder={false}
            />
        </div>
    );
}

export default PunishmentsPage;
